"use client";
import { j as e } from "./index.es176.js";
import { useState as h, useMemo as u, useEffect as b } from "react";
import { makeUniqueId as g, composeClassNames as v } from "./index.es282.js";
import x from "./index.es435.js";
import j from "./index.es436.js";
const S = ({
  header: l,
  headingLevels: t = 2,
  children: m = null,
  isOpen: a = !1,
  onClick: o = void 0,
  isBackgroundWhite: p = !1,
  langAriaSteps: f,
  contentId: i
}) => {
  const [r, n] = h(a), s = u(() => g(), []), c = () => {
    n(!r);
  };
  return b(() => {
    n(a);
  }, [a]), /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: v(
        "bl-accordion",
        p && "bl-accordion--is-white",
        r ? "bl-accordion--is-open" : "bl-accordion--is-closed"
      ),
      children: [
        /* @__PURE__ */ e.jsx(
          x,
          {
            headingLevel: t,
            className: "bl-accordion__header",
            children: /* @__PURE__ */ e.jsx(
              j,
              {
                header: l,
                onClick: o || c,
                onKeyDown: (d) => {
                  d.key === "Enter" && (d.preventDefault(), o ? o() : c());
                },
                "aria-expanded": r ? "true" : "false",
                "aria-controls": i || s,
                langAriaSteps: f
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx("div", { id: i || s, className: "bl-accordion__content", children: m })
      ]
    }
  );
};
export {
  j as AccordionHeaderButton,
  x as AccordionHeaderTag,
  S as default
};
//# sourceMappingURL=index.es365.js.map
